export default __webpack_public_path__ + "static/media/c-delete-icon.f18504c6.svg";